// All English copy in one place.
export const COPY = {
  brand: "DateSpeak",
  tagline: "what they actually said.",
  nav_decode: "DECODE",
  nav_fups: "PHRASE BANK",
  nav_how: "HOW IT WORKS",

  hero_kicker: "DATING CHATS, DECODED",
  hero_title_1: "What they said.",
  hero_title_2: "What they actually meant.",
  hero_sub: "Paste a message. We translate it through modern psychology and Indian sociocultural context — razor sharp, zero diplomacy, no therapy speak. The subtitle they didn't want you to see.",
  hero_cta: "DECODE A MESSAGE",
  hero_ticker_say: "WHAT THEY SAID",
  hero_ticker_mean: "WHAT THEY MEANT",

  section_decode: "01 / DECODER",
  decode_title: "Drop the message. Get the truth.",
  tab_text: "PASTE TEXT",
  tab_image: "UPLOAD SCREENSHOT",
  placeholder_text: "Paste their exact message here. Verbatim. Don't paraphrase.",
  label_speaker: "Speaker is",
  speaker_male: "He said it",
  speaker_female: "She said it",
  speaker_unknown: "Not sure",
  submit: "DECODE",
  submitting: "DECODING…",
  clear: "CLEAR",
  drop_text: "Drop a chat screenshot, or click to choose",
  drop_hint: "PNG · JPEG · WEBP",

  output_kicker: "DATESPEAK DECODED",
  output_meaning: "What they actually mean",
  output_intent: "Intent",
  output_vibe: "Vibe",
  output_framework: "Why people do this",
  output_not_about_you: "And — it isn't about you",
  output_actionable: "Do this next",
  output_reply: "A reply you could send",
  output_red: "Red flags",
  output_green: "Green flags",
  error_input: "Paste text or upload a screenshot first.",
  error_decode: "Decoder is unreachable. Try again in a moment.",

  section_how: "02 / HOW",
  how_title: "Three steps. No fluff.",
  how_1_t: "Paste or upload",
  how_1_b: "Drop the exact message they sent, or a screenshot of the chat.",
  how_2_t: "Set context",
  how_2_b: "Tell us who said it. We adjust for tone, gendered double-standards, and the unspoken script.",
  how_3_t: "Read the truth",
  how_3_b: "Get the raw meaning, the psychology behind it, and a reply you could actually send.",

  section_fups: "03 / PHRASE BANK",
  fups_title: "The lines they keep using.",
  fups_sub: "Common dating-chat phrases — and what they actually mean.",
  fups_search: "Search a phrase…",
  fups_all: "ALL",
  fups_men: "MEN SAY",
  fups_women: "WOMEN SAY",
  fups_intent: "Intent",
  intent_all: "All intents",
  intent_hookup: "Hookup",
  intent_situationship: "Situationship",
  intent_serious: "Serious",
  intent_ambiguous: "Ambiguous",
  intent_avoidance: "Avoidance",
  intent_validation: "Validation",
  fups_meaning: "Real meaning",
  fups_spice: "Spice",

  footer_disc: "DateSpeak is a decoder, not a verdict. Consent, context, and your gut still get the final word.",
  footer_rights: "© DateSpeak. No diplomacy included.",

  counted: (n) => `${n} phrases in the bank`,
};

// Hero ticker pairs — "what they said" → "what they meant"
export const TICKER_PAIRS = [
  ["hey", "Bare minimum. Carry the whole conversation? They'll see."],
  ["wyd", "Bored, scrolling. You're tab number five."],
  ["let's vibe", "No labels. No commitment. Ghost incoming."],
  ["you up?", "Booty call. Nothing more."],
  ["not looking for anything serious", "Believe them the first time."],
  ["drinks at my place?", "Sex, dressed as hospitality."],
  ["let's take it slow", "Keeping you on the bench."],
  ["we'll see", "Polite no. Move on."],
  ["I'll let you know", "They won't."],
  ["you're different", "Opening line. Every. Single. Time."],
  ["Netflix and chill?", "Sex, with a streaming alibi."],
  ["let's not put a label on it", "All perks. Zero responsibility."],
  ["I just got out of something", "Emotionally unavailable. Looking for a soft landing."],
  ["my ex was crazy", "You're next."],
];
